import React from 'react';
import { VideoTextProps } from '@/components/image-text/types';
import { VideoPlayer } from '@/components/video-player/VideoPlayer';
import SerializeDescription from '@/components/serialize-description/SerializeDescription';
import clsx from 'clsx';
import { imageTextThemeClasses } from '@/components/image-text/theme';

export const VideoAndText: React.FC<VideoTextProps> = ({
  title,
  description,
  video,
  theme = 'light',
}) => {
  return (
    <div
      className={clsx('relative my-10 w-full py-4', {
        [imageTextThemeClasses.root(theme)]: true,
      })}
    >
      <div className="smzh-video-text container relative z-10 mx-auto grid grid-cols-4 items-start justify-between gap-6 px-4 py-14 sm:px-0 md:grid-cols-12 md:gap-14">
        <h2
          className={clsx(
            'col-span-full flex flex-col gap-10 text-3xl font-bold md:col-start-1 md:col-end-6 md:text-4xl',
            {
              [imageTextThemeClasses.title(theme)]: true,
            },
          )}
        >
          {title}
        </h2>
        {description && (
          <div
            className={clsx(
              'col-span-full text-base font-medium md:col-start-6 md:col-end-13 md:text-base',
              {
                [imageTextThemeClasses.description(theme)]: true,
              },
            )}
          >
            <SerializeDescription description={description} />
          </div>
        )}
        {video && (
          <div className="col-span-full">
            <VideoPlayer {...video} className="!px-0" />
          </div>
        )}
      </div>
    </div>
  );
};
